import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import Select from '../../../form-controls/Select';
import { PropsFromRedux } from '.';
import disabledRedImg from '../../../../assets/icons/fadeout-radio.svg';
import redImg from '../../../../assets/icons/red-round.svg';


interface Props extends PropsFromRedux {
  alphaData : any
  setAlphaData: Function
}

interface Inputs {
    ServiceProvider : string;
}

const PickupStation: React.FC<Props> = ({ 
  hideModal,
  showModal,
  modal,
  alphaData,
  setAlphaData }) => {
  
  const history = useHistory();
  const closeModal = () => {
    hideModal();
  }

  const itemArray  = [
    { value: '1', name: 'MTN' },
    { value: '2', name: '9mobile' },
    { value: '3', name: 'Airtel' },
    { value: '3', name: 'Globacom' },
  ];
  
  const schema = yup.object().shape({
    ServiceProvider: yup.object().required()
    .typeError('Network Provider is required'),
  });

  const onSubmit = async (data: Inputs) => {}

  const pickupOption = () => {
    hideModal();
    showModal({
        component: 'PaymentMethod',
        modalProps: {
          contentLabel: 'Payment Method modal',
        }
      });
  }

  const { handleSubmit, control, errors, reset, watch, setValue } = useForm<Inputs>({
    resolver: yupResolver(schema),
});
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
   
          <div className="w-full px-2 bg-white lg:px-10 py-10 relative">
                 <Link className="mt-4 lg:mb-0 font-bold" to={{ pathname: '/bill-payment' }}>
                        <HiOutlineArrowNarrowLeft className="inline-flex text-2xl font-bold mr-3 mt-6" />
                </Link>
                <button type="button" aria-label="Close" onClick={closeModal}>
                    <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-16" />
                </button>
            <div className="w-full my-2 border-b border-gray-300 flex items-center justify-center ">
                <h3 className="text-gray-500 pb-4">Select Pickup station</h3>
            </div>
            <div className="mb-5 text-sm text-gray-500 font-medium"> 
                <Controller
                  name="ServiceProvider"
                  control={control}
                  defaultValue=""
                  render={({ name, value, onChange }) => (
                    <Select
                    name={name}
                    value={itemArray.find(c => c.name === value)}
                    id={name}
                    wrapperClassName="w-full"
                    valueKey="name"
                    labelKey="name"
                    error={errors['ServiceProvider']}
                    label=""
                    labelClassName="mb-2 flex"
                    placeholder="Select Station"
                    customChange={onChange}
                    className="rounded-md my-4"
                    options={itemArray}
                    // noOptionsMessage={() =>
                    //   paymentItemState?.loading ? 'Loading...' : 'No bundle found'
                    // }
                />
                  )}
                  
                />
        </div>
            <div className="w-full my-4">
                <div className="w-full flex">
                     <img src={redImg} alt="GIG App" className="-mt-6" />
                    <div className="p-4">
                        <h3 className="text-md font-semibold mb-1">Sango Otta</h3>
                        <p>3, Abeokuta – Lagos Expressway, Sango Ota, Opp. Sango Bridge</p>
                    </div>
                </div>
            </div>
               
            <div className="w-full my-4 border-b border-gray-400 opacity-50">
                <div className="w-full flex">
                     <img src={disabledRedImg} alt="GIG App" className="-mt-6" />
                    <div className="p-4">
                        <h3 className="text-md font-semibold mb-1">Abeokuta 1</h3>
                        <p>62, Tinubu Street, Ita Eko, Abeokuta, Ogun State</p>
                    </div>
                </div>
            </div>
               
            <div className="w-full my-4 border-b border-gray-400 opacity-50">
                <div className="w-full flex">
                     <img src={disabledRedImg} alt="GIG App" className="-mt-6" />
                    <div className="p-4">
                        <h3 className="text-md font-semibold mb-1">Abeokuta 2</h3>
                        <p>Alumni Building , Federal University of Agric (FUNAAB) Abeokuta, Ogun State
</p>
                    </div>
                </div>
            </div>

            <button className="w-full mt-6 bg-gray-400 font-medium text-sm rounded text-white py-3" type="button" 
        onClick={() => pickupOption()}>Proceed with Pickup center</button>
        </div>
        </form>
  );
  // </ModalWrapper>
};

export default PickupStation;